import React from "react";
import "./Home.css";

const Aboutus = () => {
  return (
    <div className="about-us-container">
      <h1 className="about-heading">About Us</h1>

      <p className="about-text">
        <strong>Adnya Technologies</strong> is a passionate technology firm
        founded by <strong>Jitendra Patil</strong>, a seasoned software
        developer with over 18 years of experience in the IT industry,
        including 12+ years in software development and data engineering.
        <br /><br />
        We specialize in delivering customized, scalable, and secure software
        solutions tailored to meet the unique needs of small businesses,
        clinics, educational institutions, housing societies, and local enterprises.
      </p>

      <h2 className="about-subheading">What We Do</h2>
      <ul className="about-list">
        <li>Custom mobile app development (Android/iOS) using React Native</li>
        <li>Backend systems using Java Spring Boot and PostgreSQL</li>
        <li>Medical and OPD clinic management solutions (e.g., <strong>Doctor Plus</strong>)</li>
        <li>Society management and school ERP systems</li>
        <li>Cloud hosting, deployment, and ongoing support</li>
        <li>Data migration, reconciliation, and reporting for banks and corporates</li>
      </ul>

      <h2 className="about-subheading">Why Choose Us?</h2>
      <ul className="about-list">
        <li>18+ years of professional experience</li>
        <li>Personalized attention and fast communication</li>
        <li>Trusted by clients in healthcare, education, housing, and utilities</li>
        <li>Affordable pricing with long-term support</li>
        <li>End-to-end service from design to deployment</li>
      </ul>

      <h2 className="about-subheading">Let’s Build Together</h2>
      <p className="about-text">
        Whether you're a doctor, school administrator, business owner, or society
        manager, we’re here to turn your ideas into reality with modern, reliable
        software solutions. Reach out today to discuss how we can help your digital journey.
      </p>
    </div>
  );
};

export default Aboutus;
